<template>
  <div v-if="!load" class="d-flex justify-center align-center " style="height: 75vh">
    <semipolar-spinner
        :animation-duration="2000"
        :size="115"
        color="#1935ff"
    />
  </div>
  <v-card v-else>
      <v-row class="text-left justify-center" no-gutters>
        <v-col cols="11">
          <v-card-title style="color: #1D71B8" class="px-0 mx-0 pb-0">
            <v-btn
              @click="returnParent()" class="  black--text" icon >
            <v-icon style="color: #1D71B8">arrow_back</v-icon>
          </v-btn>
            <span class="pl-3">
               {{ delail.name }}
            </span>
           </v-card-title>
          <v-card-title class="text-left px-0 " style="word-break: break-word">{{ delail.description }}</v-card-title>
          <v-autocomplete
            label="Вакцинация против covid-19"
            v-model="value.vaccinated.kor"
            :items="selectors.vaccinated"
          ></v-autocomplete>
          <v-autocomplete
            label="Вакцинация против кори"
            v-model="value.vaccinated.covid"
            v-if="value.vaccinated.kor !== null"
            :items="selectors.vaccinated"
          ></v-autocomplete>
          <v-date-picker
              v-if="value.vaccinated.covid !== null"
              ref="calendar"
              v-model="value.day"
              :allowed-dates="allowedDates"
              :first-day-of-week="1"
              :landscape="$vuetify.breakpoint.mdAndUp"
              :weekdays="{ text: 'Пон - Воскр', value: [1, 2, 3, 4, 5, 6, 0] }"
              class="mt-4"
              clearable
              full-width
              @update:picker-date="changeMonth"
          ></v-date-picker>
          <div v-if="intervals.length > 0" class="py-4">
            <v-autocomplete
                v-model="value.interval"
                :error="hasError('interval')"
                :error-messages="getError('interval')"
                :item-text=dateInterval
                :items="intervals"
                item-value="id"
                label="Время записи"
                :item-disabled="(val)=>{return  !val.allow}"
            >
            </v-autocomplete>
            <v-text-field
                v-model="value.lastname"
                :error="hasError('lastname')"
                :error-messages="getError('lastname')"
                label="Фамилия"
            >
            </v-text-field>
            <v-text-field
                v-model="value.firstname"
                :error="hasError('firstname')"
                :error-messages="getError('firstname')"
                label="Имя"
            >
            </v-text-field>
            <v-text-field
                v-model="value.midname"
                :error="hasError('midname')"
                :error-messages="getError('midname')"
                label="Отчество"
            >
            </v-text-field>
            <v-text-field
                v-model="value.email"
                :error="hasError('email')"
                :error-messages="getError('email')"
                label="Почта для регистрации"
            >
            </v-text-field>
            <v-alert v-if="hasError('non_field_errors')" type="error">
              {{ String(getError('non_field_errors')) }}
            </v-alert>
            <v-alert v-if="hasError('user')" type="error">
              {{ String(getError('user')) }}
            </v-alert>
            <v-alert v-if="hasError('error')" type="error">
              {{ String(getError('error')) }}
            </v-alert>
            <v-alert v-if="hasError('event')" type="error">
              {{ String(getError('event')) }}
            </v-alert>
              <v-row align="center"
                     justify="center">
              <v-btn text outlined rounded :color="'#1D71B8'"  @click="saveRegistration()">Записаться</v-btn>
              </v-row>
          </div>
        </v-col>
      </v-row>

    </v-card>
</template>

<script>
import urls from "@/urls/helper";
import {loadData, sendPostRequest} from "@/helper/requests";
import imgCart from "@/assets/fone.jpg"
import {SemipolarSpinner} from "epic-spinners";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import names from "@/modules/recording/routers/names";

export default {
  name: "Category",
  components: {
    SemipolarSpinner
  },
  mixins: [FormErrorsMixin],
  computed: {},
  watch: {
    'value.day': function (val) {
      this.loadInterval()
    },
    'vaccinated.covid': function (val) {
      this.date = String(new Date().toISOString().slice(0, 10))
      this.changeMonth(this.date)
      // this.loadDates(String(new Date().toISOString().slice(0, 10)))
    },
  },
  data() {
    return {
      imgCart: imgCart,
      errLoad: false,
      load: false,
      delail: {},
      monthDay: [],
      selectors:{
        vaccinated:[]
      },
      intervals: [],
      date: null,
      value: {
        vaccinated: {
          "covid": null,
          "kor": null
        },
        day: null,
        interval: null,
        email: '',
        lastname: '',
        firstname: '',
        midname: '',
      }
    }
  },
  methods: {
    returnParent() {
      this.$router.push({name: names.BASE})
    },
    dateInterval(val) {
      let full =''
      if (!val.allow)
        full ='(запись закрыта)'
      return val.started + " - " + val.ended + " " +full
    },

    saveRegistration() {
          this.errors.fields = []
          sendPostRequest(
          urls.getRecordingUrlWithParameters('user|event|records-create', 'post', {
            event: this.$route.params.event,
          }), this.value,
          (json) => {
            this.$router.push({name: names.PUBLIC.TOKEN,params:{code: json.code}})
          },
          (json) => {
            this.errors.fields = (json);

          });
    },
    allowedDates(val) {
      let allow = this.monthDay.find((value => {
        return (value.day === val) && (value.allow)
      }))
      return allow
    },
    loadvaccinated(){
      loadData(
          urls.getRecordingUrlWithParameters('choices|vaccinated', 'get', {
      event: this.$route.params.event,

    }), (data) => {
            this.selectors.vaccinated = (data);
          }
      )
    },
    loadDates(month = undefined, year = undefined) {
      loadData(
          urls.getRecordingUrlWithParameters('selector|event|dates', 'get', {
            event: this.$route.params.event,
            month: month,
            year: year
          },{vaccinated:this.vaccinated}),
          (data) => {
            this.monthDay = data
            this.value.day = null
          }
      )
    },
    loadInterval() {
      let allow = this.monthDay.find((value => {
        return (value.day === this.value.day) && (value.allow)
      }))
      if (allow) {
        loadData(
            urls.getRecordingUrlWithParameters('selector|date|intervals', 'get', {day: allow.day, event: this.$route.params.event,}),
            (data) => {
              this.intervals = data
            }
        )
      } else {
        this.intervals = []
      }

    },

    changeMonth(event) {
      event = event.split('-');
      let month = parseInt(event[1]);
      let year = parseInt(event[0]);
      this.loadDates(month, year)
    },

  },

  created() {
    // this.date = new Date().toISOString().slice(0, 10)
    loadData(
        urls.getRecordingUrlWithParameters('events-detail', 'retrieve', {id: this.$route.params.event}),
        (data) => {
          this.delail = data
          this.load = true
          this.loadvaccinated();
        }
    )
  }
}
</script>

<style scoped>

.succesbtn {

  border-radius: 44px !important;
  border: 1px;
  gap: 10px;

}
</style>
